const AUTH_RETURN_PATH_KEY = "auth.returnPath";

export const buildCurrentPath = () =>
    `${window.location.pathname}${window.location.search}${window.location.hash}`;

const isSafeReturnPath = (path) =>
    typeof path === "string"
    && path.startsWith("/")
    && !path.startsWith("/oauth")
    && !path.startsWith("/login");

/** Save SPA path before OAuth login/logout redirect. */
export const saveAuthReturnPath = (path = buildCurrentPath()) => {
    if (!isSafeReturnPath(path)) {
        return;
    }
    sessionStorage.setItem(AUTH_RETURN_PATH_KEY, path);
};

/**
 * OAuth usually redirects to `/` first. Restore the saved path in the address bar
 * before React mounts so the first paint already shows the target page.
 */
export const applyAuthReturnPathBeforeRender = () => {
    const path = sessionStorage.getItem(AUTH_RETURN_PATH_KEY);
    if (!isSafeReturnPath(path) || buildCurrentPath() === path) {
        return;
    }
    if (window.location.pathname !== "/" || window.location.search || window.location.hash) {
        return;
    }
    window.history.replaceState(null, "", path);
};

/** Read saved path once and remove it from storage. */
export const consumeAuthReturnPath = () => {
    const path = sessionStorage.getItem(AUTH_RETURN_PATH_KEY);
    sessionStorage.removeItem(AUTH_RETURN_PATH_KEY);
    return isSafeReturnPath(path) ? path : null;
};
